import Tipe61 from "./tipe6 (1).webp";
import Tipe62 from "./tipe6 (2).webp";

const tipe6 = [Tipe61, Tipe62];

export default tipe6;
